var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-state-label"},[_c('v-chip',{class:'mt-5 text-uppercase font-weight-bold center-label-' + 
      _vm.reviewState,attrs:{"label":""}},[_vm._v(" "+_vm._s(_vm.centerReviewStates[this.reviewState])+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }